import logo from "../../../assets/image/logo.png";
import styles from "./General.module.css";

interface GeneralProps {
    mensagem?: string;
}

export default function General({ mensagem }: GeneralProps) {
    return(
        <section className={styles.General}>
            <img src={logo} alt="Logo do ISM" />

            <span> {mensagem ?? "Erro de redirecionamento, confira o link digitado."} </span>

            <span className={styles.suporte}> Precisa de ajuda? Entre em contato com o suporte: suporte@influenciesuamarca.com.br </span>
        </section>
    )
}
